import { render, staticRenderFns } from "./StyleInventory.vue?vue&type=template&id=5e5bcbc2&lang=html&"
import script from "./StyleInventory.vue?vue&type=script&lang=js&"
export * from "./StyleInventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports